/**
 * Operation name of layer.authoring.status.query.gql; refetched by every
 * mutation that changes catalog rows (save, promote, delete, restore) so
 * the production chips stay accurate.
 */
export const LAYER_AUTHORING_STATUSES_QUERY_NAME = "LayerAuthoringStatusesQuery"

/** ProdState values reported by getLayerAuthoringStatuses. */
export const PROD_STATE = {
  devOnly: "dev-only",
  outdated: "prod-outdated",
  inProd: "in-prod",
} as const
